module.exports = __webpack_public_path__ + "static/media/payments.cbf92599.svg";